import { transformBannerCategory } from '../../../utils/gaUtils';
import { openPrismicLink } from '../../../actions/prismicActions';
import { trackBannerOnDisplayWeb } from '../../../utils/generalGaEventAnalytics';

export const gaBannerClick = (
  gaLob: string[],
  title: string,
  bannerAction: string,
  campaignName: string,
  bannerCategory: string,
  customBannerCategory: string,
) => {
  try {
    const transformedBannerCategory = transformBannerCategory(
      bannerCategory,
      customBannerCategory,
    );
    trackBannerOnDisplayWeb(
      gaLob,
      gaLob,
      `Blog - ${title}`,
      bannerAction,
      campaignName,
      transformedBannerCategory,
    );
  } catch (e) {
    console.error(e);
  }
};

export const formatPromoCards = (
  data,
  lang,
  gaLob,
  tab?: 'events' | 'offers',
  limit?: number,
  gaBannerTitlePrefix?: string,
) => {
  const result = data
    ?.map((item) => {
      const link = item.data?.['link-WEB'] || {};
      const linkQueue = item.data?.['link-queue'] || {};
      const linkType = item.data?.['link-type'] || {};
      const date = item.data?.['display_date'] || '';
      const time = item.data?.['display_time'] || '';
      const type = item.type;
      const prismicBannerId = item.id;
      const title = item.data?.title || '';
      const gaCampaignName = item.data?.ga_campaign_name || '';
      const gaBannerCategory = item.data?.ga_banner_category || '';
      const gaCustomBannerCategory = item.data?.ga_custom_banner_category || '';
      const bannerPrefix = gaBannerTitlePrefix
        ? gaBannerTitlePrefix
        : tab
        ? tab
        : '';

      return {
        uid: item.id,
        title: title,
        description: item.data.content || '',
        imgTitle: item.data.thumbnail[0].img_title,
        sequence: item.data.priority,
        durationInMs: item.data.duration * 1000,
        remarkText: item.data.campaign_notice?.[0]?.text || '',
        remarkIconKey: item.data.campaign_notice?.[0]?.icon ?? '',
        src: item.data.thumbnail[0].image.src,
        language: item.data.campaign_language || '',
        dateTime: `${date}${date && time && ' '}${time}`,
        link,
        linkQueue,
        linkType,
        type,
        keyHighlight: item.data.key_focus || '',
        gaCampaignName,
        gaBannerCategory,
        gaCustomBannerCategory,
        onClick: () => {
          gaBannerClick(
            gaLob,
            `${bannerPrefix ? `${bannerPrefix} - ` : ''}${title}`,
            'click',
            gaCampaignName,
            gaBannerCategory,
            gaCustomBannerCategory,
          );
          openPrismicLink(link, linkQueue, linkType, lang, prismicBannerId);
        },
      };
    })
    ?.sort((a, b) => {
      const sequenceA = a.sequence || 0;
      const sequenceB = b.sequence || 0;
      return sequenceA - sequenceB;
    });

  return limit ? result?.slice(0, limit) : result;
};
